const PURPOSES: Readonly<Record<string, string>> = {
  E_PAY: 'make your payment',
  SURPLUS_NOTICE: 'review and sign your surplus lines notice',
  INSURED_PROOF_OF_LOSS: 'upload documents for your claim',
  RISK_DATA_QUESTIONNAIRE: 'answer your risk data questionnaire',
};

/**
 * What the code lets the person do, by the flow being entered. The flow is known only once a code has been sent, so
 * the page says "continue" until then. Flows with no wording of their own are quotes.
 */
export const accessCodePurpose = (flow?: string | null): string => {
  if (!flow) {
    return 'continue';
  }
  return PURPOSES[flow] ?? 'view your quote';
};

/** The line under the page's title. */
export const accessCodeIntro = (flow?: string | null): string =>
  `To keep your information safe, we'll send you a one-time, 6-digit code. Enter it below to ${accessCodePurpose(
    flow
  )}.`;

export type CodeChannel = 'email' | 'phone';

interface CodeSentTo {
  readonly flowUserEmail?: string | null;
  readonly flowUserPhone?: string | null;
}

/** Where the code went, said on the page in place of the old modal. */
export const codeSentMessage = (
  channel: CodeChannel,
  sentTo: CodeSentTo
): string => {
  const address =
    channel === 'email' ? sentTo.flowUserEmail : sentTo.flowUserPhone;
  const where = address ? ` to ${address}` : '';
  return `We sent a code${where}. It expires in 5 minutes.`;
};
